// File Metadata:
// Filename: ProtectedRoute.jsx
// Version: 1.00
// Created: 2025-04-09 22:25:20
// Last Modified: 2025-04-11 21:16:42
// Authors: Dieuwer Descheemaecker// Description: A brief summary of what this file does

// File: G:/Development/Projects/familysync/frontend/src/components/ProtectedRoute.jsx
// Add new file
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, role, redirectTo = '/' }) => {
  const user = useSelector((state) => state.user.data);
  if (!user) return <Navigate to="/login" />;

  if (role) {
    const allowedRoles = Array.isArray(role) ? role : [role];

    if (!allowedRoles.includes(user.role)) {
      return <Navigate to={redirectTo} />;
    }
  }

  return children;
};

export default ProtectedRoute;